// components/Header.js
import React, { useState, useEffect } from 'react';
import './Header.css';

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleLinkClick = (e, target) => {
    e.preventDefault();
    const element = document.querySelector(target);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80, // Adjust offset as needed
        behavior: 'smooth',
      });
    }
    if (isOpen) {
      toggleMenu();
    }
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''} ${isOpen ? 'menu-open' : ''}`}>
      <div className="logo">
        <a href="#home" onClick={(e) => handleLinkClick(e, '#home')}>Suite 360</a>
      </div>
      <button className="menu-toggle" onClick={toggleMenu}>
        <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
      </button>
      <nav className={`nav-menu ${isOpen ? 'open' : ''}`}>
        <ul>
          <li><a href="#home" onClick={(e) => handleLinkClick(e, '#home')}>Home</a></li>
          <li><a href="#about" onClick={(e) => handleLinkClick(e, '#about')}>About</a></li>
          <li><a href="#rooms" onClick={(e) => handleLinkClick(e, '#rooms')}>Rooms</a></li>
          <li><a href="#gallery" onClick={(e) => handleLinkClick(e, '#gallery')}>Gallery</a></li>
          <li><a href="#contact" onClick={(e) => handleLinkClick(e, '#contact')}>Contact</a></li>
        </ul>
        <a href="#booking" onClick={(e) => handleLinkClick(e, '#booking')} className="btn-primary btn-book-now">Book Now</a>
      </nav>
    </header>
  );
}

export default Header;
